var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountMultipleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "account-multiple-outline",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M13.07 10.41a5 5 0 0 0 0-5.82 3.5 3.5 0 1 1 0 5.82ZM5.5 7.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm2 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM16 17v2H2v-2s0-4 7-4 7 4 7 4Zm-2 0c-.14-.78-1.33-2-5-2s-4.93 1.31-5 2h10Zm1.95-4A5.32 5.32 0 0 1 18 17v2h4v-2s0-3.63-6.06-4h.01Z",
    fill: "#605E5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMultipleOutline);
export default __webpack_public_path__ + "static/media/account-multiple-outline.5595907c76fc25ef8c540b9098f35312.svg";
export { ForwardRef as ReactComponent };